module.exports = __webpack_public_path__ + "img/location.f4ba6d1.jpg";